import {
  FlightSelectors,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getLocatorsWithLabelFromItinerary } from "@hopper-b2b/utilities";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const FlightConfirmationNumbersSection = () => {
  const { t } = useI18nContext();

  const itinerary = useSelector(FlightSelectors.getFinalizedItinerary);
  const airlineMap = useSelector(FlightSelectors.getAirlineMap);
  const locatorsWithLabels = getLocatorsWithLabelFromItinerary({
    itinerary,
    airlineMap,
  });
  const flightConfirmationCode = itinerary.locators.agent.unscopedValue;

  return (
    <div
      className={clsx(
        "mobile-trip-details-confirmation-numbers-container",
        styles.flightConfirmationSection
      )}
    >
      <h3 className="mobile-trip-details-reservation-numbers-title">
        {t("reservationNumbers")}
      </h3>
      <div className="mobile-trip-details-confirmation-numbers-container">
        {locatorsWithLabels
          ? locatorsWithLabels.map((locatorWithLabel, i) => {
              return (
                <div
                  className="mobile-trip-details-confirmation-number"
                  key={`flight-confirmation-numbers-${i}`}
                >
                  <p className="flight-confirmation-number">
                    {locatorWithLabel.locator}
                  </p>
                  <p className="flight-confirmation-label">
                    {locatorWithLabel.label}
                  </p>
                </div>
              );
            })
          : null}
        {flightConfirmationCode ? (
          <div className="mobile-trip-details-confirmation-number">
            <p className="flight-confirmation-number">
              {flightConfirmationCode}
            </p>
            <p className="flight-confirmation-label">{t("uber")}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
};
